// extracted by mini-css-extract-plugin
export default {"celebrate":"banner1_celebrate__Y6o+R","celebrate_back":"banner1_celebrate_back__l-ig0"};